import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { agentAxiosObj } from "../../../config/apiClients";
import { SalesEsouqOrderState } from "../../types";
import { queryParams } from "../../../utils/interface";

const initialState: SalesEsouqOrderState = {
  isLoading: false,
  clientsOrders: [],
  pagination: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
}

export const getAllOrders = createAsyncThunk(
  "/withdraw/getAll",
  async ({ paramPage, paramLimit, search, startDate, endDate }: queryParams, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      if (startDate) params.append("startDate", startDate as string);
      if (endDate) params.append("endDate", endDate as string);
      if (search) params.append("search", search);
      if (paramPage) params.append("paramPage", String(paramPage));
      if (paramLimit) params.append("paramLimit", String(paramLimit));

      const response = await agentAxiosObj.get(
        `/esouq-orders${params.toString() ? `?${params.toString()}` : ""}`);
      return response.data
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Esouq Orders' });
    }
  }
)

const agentEsouqOrdersSlice = createSlice({
  name: "agentEsouqOrders",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientsOrders = action.payload.payload.clientsOrders;
        state.pagination = {
          totalItems: action.payload.payload.totalItems,
          currentPage: action.payload.payload.page,
          totalPages: action.payload.payload.totalPages,
          hasNextPage: action.payload.payload.hasNextPage
        };
      })
      .addCase(getAllOrders.rejected, (state) => {
        state.isLoading = false;
        state.clientsOrders = []
      })
  }
})

export default agentEsouqOrdersSlice.reducer;